exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".fade-appear, .fade-enter {\n  opacity: 0;\n}\n.fade-appear-active, .fade-enter-active {\n  opacity: 1;\n  transition: opacity 500ms ease-in;\n}\n.fade-exit {\n  opacity: 1;\n}\n.fade-exit-active {\n  opacity: 0;\n  transition: opacity 500ms ease-in;\n}\n", ""]);
